import { render, staticRenderFns } from "./MyTodoList.vue?vue&type=template&id=153abb08&scoped=true&"
import script from "./MyTodoList.vue?vue&type=script&lang=js&"
export * from "./MyTodoList.vue?vue&type=script&lang=js&"
import style0 from "./MyTodoList.vue?vue&type=style&index=0&id=153abb08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153abb08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153abb08')) {
      api.createRecord('153abb08', component.options)
    } else {
      api.reload('153abb08', component.options)
    }
    module.hot.accept("./MyTodoList.vue?vue&type=template&id=153abb08&scoped=true&", function () {
      api.rerender('153abb08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/eletronicSigned/MyTodoList.vue"
export default component.exports